import { $applyNodeReplacement } from "lexical";
import { MentionNode } from "./MentionNode.js";
function $createMentionNode(mentionId, mentionName, mentionLogo, mentionType) {
    const mentionNode = new MentionNode(()=>mentionNode.remove(), mentionId, mentionName, mentionLogo, mentionType);
    return $applyNodeReplacement(mentionNode);
}
function $isMentionNode(node) {
    return node instanceof MentionNode && !!node.getMentionId();
}
function $convertElement() {
    const node = $createMentionNode();
    return {
        node
    };
}
export { $convertElement, $createMentionNode, $isMentionNode };
